import { jobStatusOptions } from "src/utils/options";

export const jobStatusLabelByValue: Record<string, string> = Object.fromEntries(
	jobStatusOptions.map((option) => [option.value, option.label])
);

export const jobStatusVariantByLabel: Record<string, string> =
	Object.fromEntries(
		jobStatusOptions.map((option) => [option.label, option.variant])
	);

// Final job statuses — no further transitions are allowed from these.
const CLOSED_JOB_STATUSES = new Set(["completed", "incomplete", "cancelled"]);

export function isJobClosed(status: string): boolean {
	return CLOSED_JOB_STATUSES.has(status);
}

export function jobStatusLabel(status: string): string {
	return jobStatusLabelByValue[status] || status;
}

export function assignedToLabel(assignedTo?: {
	id?: string | number;
	display?: string;
}): string | number {
	return assignedTo?.display || assignedTo?.id || "-";
}

// Mock priority is a lowercase string ("high"); no numeric code to map
// through priorityOptions here, so just title-case it for display.
export function priorityLabel(priority?: string): string {
	return priority
		? priority.charAt(0).toUpperCase() + priority.slice(1)
		: "-";
}
